import { render, staticRenderFns } from "./TariffList.vue?vue&type=template&id=193e11bc&"
import script from "./TariffList.vue?vue&type=script&lang=ts&"
export * from "./TariffList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports